module.exports = __webpack_public_path__ + "static/media/resume.98bf82dd.jpg";